import type { IDropdownChild, IDropdownItem } from "@similarweb/ui-components";
import type { ReactElement } from "react";

export const buildDropdownSelectedItemsFromArray = <Value extends string | number>(
    selectedOptions: ReadonlyArray<Value>,
    initialItems?: Record<Value, boolean>,
): Record<Value, boolean> => {
    const selectedItems = initialItems ? { ...initialItems } : ({} as Record<Value, boolean>);

    for (const option of selectedOptions) {
        selectedItems[option] = true;
    }

    return selectedItems;
};

export const getDropdownChildId = (item: IDropdownChild): string | number | undefined => {
    // @ts-expect-error error TS2339: Property 'id' does not exist on type 'unknown'
    const { id } = (item as ReactElement)?.props ?? (item as IDropdownItem);

    return id;
};

const getDropdownItemText = (item: IDropdownChild): string | undefined => {
    const element = item as ReactElement;
    const objectItem = item as IDropdownItem;

    if (element.props) {
        // @ts-expect-error error TS2339: Properties 'children' & 'text' do not exist on type 'unknown'
        return element.props.text ?? element.props.children;
    }

    return objectItem.text;
};

export const searchDropdownItems = (term: string, item: IDropdownChild): boolean => {
    const searchValue = getDropdownItemText(item) ?? "";

    return searchValue.toLowerCase().includes(term.toLowerCase());
};

export const createMultiselectLabel = <V extends string>(
    value: readonly V[] | null | undefined,
    fallback?: string,
): string | undefined => {
    const count = value?.length ?? 0;

    if (value == null || count === 0) {
        return fallback ?? undefined;
    }

    const first = value[0];

    if (count === 1) {
        return first;
    }

    return `${value[0]} +${count - 1}`;
};
